<template>
  <div id="line-chart"></div>
</template>
<script>
import { Chart } from '@antv/g2';
export default {
  components: {},
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      lineChart: null,
    };
  },
  watch: {
    data: {
      handler: function(newVal) {
        if (!this.lineChart) {
          this.$nextTick(() => {
            this.drawLineChart();
          });
        } else {
          const list = newVal;
          this.lineChart.changeData(list);
        }
      },
    },
  },
  created() {
    this.$nextTick(() => {
      this.drawLineChart();
    });
  },
  activated() {},
  computed: {},
  methods: {
    drawLineChart() {
      const chart = new Chart({
        container: 'line-chart',
        autoFit: true,
        height: 500,
        padding: [24, 35, 90, 50]
      });
      chart.data(this.data);
      chart.scale({
        startTime: {
          type: 'timeCat',
          mask: 'MM/DD HH:mm',
          nice: true,
        },
        onlineNum: {
          nice: true,
        },
      });
      chart.tooltip({
        showCrosshairs: false,
        showTitle: false,
        customItems: (items) => {
          items[0].name = items[0].title;
          return items;
        },
      });
      chart.option('slider', {
        height: 40,
        start: 0,
        end: 1,
        trendCfg: {
          smooth: true,
          isArea: false,
        },
      });
      
      // chart.area().position('startTime*onlineNum').color('l(90) 0:rgba(59,161,255,0.5) 1:rgba(255,255,255,0) ').shape('smooth');
      // chart.line()
      // .position('startTime*onlineNum')
      // .color('#4983F5')
      // .shape('smooth')
      // .style({
      //   stroke: '#4983F5',
      //   lineWidth: 4,
      // });
      // chart.interaction('element-visible-filter');
      chart.legend(false);
      chart
        .interval()
        .position('startTime*onlineNum')
        .size("onlineNum", () => 30);;

      chart.interaction('element-active');

      chart.render();
      this.lineChart = chart;
    },
  },
};
</script>
<style lang='scss' scoped>

/deep/ div.g2-tooltip {
  font-size: 14px !important; 
}
</style>